import React, { useContext } from 'react';
import { Placeholder } from '@thd-olt-component-react/core-ui';
import { ExperienceContext } from '@thd-nucleus/experience-context';

const DeliveryInstallationDetailsPlaceholder = () => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';

  return (
    <div data-testid="delivery-and-installation-details-placeholder-test-id">
      <Placeholder
        height={`${isMobile ? 101 : 22}px`}
        type="text"
        key={`placeholder-${channel}-0`}
      />
      {
          Array.from({ length: isMobile ? 5 : 4 }).map((_obj, i) => (
            <Placeholder
            height="40px"
            type="text"
            key={`placeholder-${channel}-${i + 1}`}
          />
        ))
      }
    </div>
  );
};

export { DeliveryInstallationDetailsPlaceholder };
